export const STAFF_PROVIDERS_LIST_QUERY_KEY = 'staff-providers-list';
export const STAFF_PROVIDER_QUERY_KEY = 'staff-provider';
export const STAFF_PROVIDER_DOCUMENTS_COUNT_QUERY_KEY = 'staff-provider-documents-count';
export const STAFF_PROVIDER_REFERENCES_QUERY_KEY = 'staff-provider-references';
export const STAFF_PROVIDER_LEGACY_FILES_QUERY_KEY = 'staff-provider-legacy-files';
export const legacyFilesQueryKey = (providerId: string) => [
  STAFF_PROVIDER_LEGACY_FILES_QUERY_KEY,
  providerId,
];
export const STAFF_PROVIDER_NOTES_QUERY_KEY = 'staff-provider-notes';
export const STAFF_PROVIDER_STATUS_HISTORY_QUERY_KEY = 'staff-provider-status-history';
export const STAFF_PROVIDER_CHANGE_HISTORY_QUERY_KEY = 'staff-provider-change-history';
